/**
 * AdminMobileMenu Component
 * Extracted from Admin.jsx - Mobile menu button and overlay
 * NO BEHAVIOR CHANGES - Pure presentational extraction
 */
import React from 'react';
import { Menu, X } from 'lucide-react';

export const AdminMobileMenu = ({ 
  sidebarOpen, 
  onToggle 
}) => {
  return (
    <>
      {/* Mobile Menu Button */}
      <button 
        className="mobile-menu-btn"
        onClick={onToggle}
        aria-label="Toggle navigation menu"
      >
        {sidebarOpen ? <X size={24} /> : <Menu size={24} />}
      </button>
      
      {/* Mobile Overlay */}
      {sidebarOpen && (
        <div 
          className="mobile-overlay"
          onClick={onToggle}
        />
      )}
    </>
  );
};

export default AdminMobileMenu;
